import React, { useState } from 'react';
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import Grid from '../layout/Grid';
import Table, { Cell, Row } from '../table/Table';
import TextField from './TextField';
import Button from './Button';
import StaffAutoComplete from './StaffAutoComplete';
import { InlineField } from '../layout/Inline';
import { DeleteIcon, EditIcon, LockIcon, TickCircleIcon } from '../IconIndex';
import { niceTimeFromString } from '../../utils/date';

const StaffAllocationTable = (
    { form, name, defaultDate, defaultTime, defaultDuration, allocationType, disabled, readOnly }
) => {
    const [activeRow, setActiveRow] = useState(null);
    const allStaffAllocations = form.getField(name) || [];
    const realStaffAllocations = allStaffAllocations.filter(obj => !(!!obj.Member && 'ReflectionRoom' === obj.Member.Email));
    const defaultBegin = moment(form.getField(defaultDate) + 'T' + form.getField(defaultTime));
    const defaultUntil = moment(defaultBegin).add(form.getField(defaultDuration), 'hours');

    const onAddRow = () => {
        const addedStaffAllocations = [].concat(allStaffAllocations, [{
            Start: defaultBegin.format('Y-MM-DD HH:mm:ss'),
            End: defaultUntil.format('Y-MM-DD HH:mm:ss'),
            Type: allocationType
        }]);
        form.setField({ [name]: addedStaffAllocations });
        setActiveRow(allStaffAllocations.length);
    };

    const onDeleteRow = (idx) => {
        const deletedStaffAllocations = allStaffAllocations.toSpliced(idx, 1);
        form.setField({ [name]: deletedStaffAllocations });
        setActiveRow(null);
    };
    const onSelectStaffMember = (Member, rowIdx) => {
        allStaffAllocations[rowIdx].Member = Member
            ? (({ __typename, ...data }) => data)(Member)
            : { ID: null };
        form.setField({ [name]: allStaffAllocations });
    };

    const onChangeDateTime = (val, name) => {
        if (val) {
            const newVal = moment(form.getField(defaultDate) + 'T' + val);
            form.setField({ [name]: newVal.format('Y-MM-DD HH:mm:ss') });
        }
    };

    const columns = [
        { label: 'Staff Allocation' },
        { label: 'Arrive' },
        { label: 'Leave' }
    ];
    if (!readOnly) {
        columns.push({ label: 'Edit', tiny: true });
    }

    return (
        <>
            {realStaffAllocations.length > 0 && (
                <Grid item>
                    <Table columns={columns}>
                        {allStaffAllocations.map((obj, idx) =>
                            !(!!obj.Member && 'ReflectionRoom' === obj.Member.Email) &&
                            (idx === activeRow && !readOnly ? (
                                <Row key={obj.ID || idx}>
                                    <Cell pad colSpan={3}>
                                        <StaffAutoComplete
                                            placeholder="Search for a staff name here"
                                            selectProps={{ multiple: false }}
                                            onSelect={(_, result) => onSelectStaffMember(result, idx)}
                                            clearOnSelect={false}
                                            value={form.getField(name + '[' + idx + '].Member.ID')}
                                            minChars={1}
                                        /><br />
                                        <TextField
                                            InputLabelProps={{ shrink: true }}
                                            label="Instructions"
                                            multiline
                                            rows={5}
                                            placeholder="Enter any notes..."
                                            form={form}
                                            name={name + '[' + idx + '].Allocation'}
                                        />
                                        <InlineField>
                                            <TextField
                                                label="Arrive"
                                                disabled={disabled}
                                                type="time"
                                                form={form}
                                                name={name + '[' + idx + '].Start'}
                                                onChange={(evt, val) => onChangeDateTime(val, name + '[' + idx + '].Start')}
                                            />
                                            <TextField
                                                label="Leave"
                                                disabled={disabled}
                                                type="time"
                                                form={form}
                                                name={name + '[' + idx + '].End'}
                                                onChange={(evt, val) => onChangeDateTime(val, name + '[' + idx + '].End')}
                                            />
                                        </InlineField>
                                    </Cell>
                                    {!readOnly && <Cell>
                                        <div style={{
                                            display: 'flex',
                                            gap: '1rem',
                                            flexWrap: 'wrap',
                                            justifyContent: 'space-between'
                                        }}>
                                            <IconButton
                                                className="icon"
                                                title="Accept"
                                                onClick={() => setActiveRow(null)} size="large">
                                                <TickCircleIcon />
                                            </IconButton>
                                            <IconButton
                                                disabled={disabled}
                                                className="icon"
                                                title="Remove"
                                                onClick={() => onDeleteRow(idx)} size="large">
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </Cell>}
                                </Row>
                            ) : (
                                <Row key={obj.ID || idx}>
                                    <Cell pad dataLabel={columns[0].label}>
                                        {obj.Member ? <>{obj.Member.FirstName}&nbsp;{obj.Member.Surname}</> : 'Staff Not Allocated'}
                                        {obj.Allocation && <small><br />{obj.Allocation}</small>}
                                    </Cell>
                                    <Cell pad dataLabel={columns[1].label}>{niceTimeFromString(obj.Start)}</Cell>
                                    <Cell pad dataLabel={columns[2].label}>{niceTimeFromString(obj.End)}</Cell>
                                    {!readOnly && <Cell>
                                        {disabled || (!!obj.Member && 'ReflectionRoom' === obj.Member.Email)
                                            ? <IconButton className="icon" disabled size="large"><LockIcon /></IconButton>
                                            : <IconButton
                                                className="icon"
                                                title="Edit"
                                                onClick={() => setActiveRow(idx)} size="large">
                                                <EditIcon />
                                            </IconButton>}
                                    </Cell>}
                                </Row>
                            )))}
                    </Table>
                </Grid>
            )}
            {!disabled && !readOnly && <Grid item>
                <Button onClick={onAddRow}>+ Add Staff Allocation</Button>
            </Grid>}
        </>
    );
};


export default StaffAllocationTable;
